var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "detail-content mb-30" }, [
      _c("div", { staticClass: "detail-content-header" }, [
        _c("p", { staticClass: "fs-20" }, [
          _vm._v(_vm._s(_vm.detailInfo.title)),
        ]),
        _c("p", { staticClass: "color-999 mt-20" }, [
          _vm._v("发布时间：" + _vm._s(_vm.detailInfo.releaseTime)),
        ]),
      ]),
      _c("div", {
        staticClass: "detail-content-body not-reset",
        domProps: { innerHTML: _vm._s(_vm.detailInfo.content) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }